function IconTrainingCourse({ fillColor = "none", strokeColor = "currentColor" }) {
  return (
    <svg width="58" height="58" viewBox="0 0 58 58" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
      <path d="M52.5311 23.6752L29.4999 11.4692L6.46875 23.6752L29.4999 35.8958L52.5311 23.6752Z" stroke={strokeColor} stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M44.7192 27.8169V45.8247H14.2852V27.8169" stroke={strokeColor} stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M52.5273 23.6748V34.5735" stroke={strokeColor} stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export default IconTrainingCourse